import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import { Observable, from, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class ScreenCaptureService {
  /**
   * Converts DOM to data image URL.
   *
   * @param  element the documemnt's element
   * @param  options the html2canvas options
   */
  public dataURL(element, options: any = {}): Observable<string> {
    const canvas$ = this.canvas(element, options);
    const image$ = canvas$.pipe(
      switchMap(canvas => {
        const data = canvas.toDataURL().replace('data:image/png;base64,', '');
        return of(data);
      }),
    );
    return image$.pipe(take(1));
  }

  /**
   * Converts DOM to canvas observable with the element and options provided.
   *
   * @param element the documemnt's element
   * @param options the html2canvas options
   */
  public canvas(element: HTMLElement, options: any = {}): Observable<HTMLCanvasElement> {
    const promise = html2canvas(element, options);
    return from(promise).pipe(take(1));
  }
}
